export default __webpack_public_path__ + "static/media/unlink.f978c307.svg";